import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import PropTypes from "prop-types";

import useSelectStyles from "./useSelectStyles";
import useSelectWrapStyles from "./useSelectWrapStyles";

const RbSelect = React.forwardRef(function RbSelect(props, ref) {
  const { options, native, onChange, onChangeValue, value, ...other } = props;

  const classesWrap = useSelectWrapStyles();
  const classes = useSelectStyles();

  const handleChange = React.useCallback(
    (event, child) => {
      if (onChange) {
        onChange(event, child);
      }
      if (onChangeValue) {
        onChangeValue(child ? child?.props?.value : event.target.value);
      }
    },
    [onChange, onChangeValue]
  );

  const renderOptions = () => {
    if (native) {
      return options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ));
    }
    return options.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ));
  };

  return (
    <Select
      classes={classes}
      className={classesWrap.root}
      ref={ref}
      {...other}
      onChange={handleChange}
      value={value ?? ""}
    >
      {renderOptions()}
    </Select>
  );
});

RbSelect.propTypes = {
  onChange: PropTypes.func,
  onChangeValue: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    })
  ),
  native: PropTypes.bool,
  value: PropTypes.any,
};

RbSelect.defaultProps = {
  onChange: undefined,
  onChangeValue: undefined,
  options: [],
  native: false,
  value: undefined,
};

export default RbSelect;
